import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Info } from 'lucide-react';
import type { ComponentProps } from 'react';

interface Props extends ComponentProps<typeof Alert> {
  header: string;
  text: string;
  containerClass?: string;
}

const BasicAlert = ({ header, text, containerClass, ...props }: Props) => {
  return (
    <Alert {...props} className={containerClass}>
      <Info />
      <AlertTitle>{header}</AlertTitle>
      <AlertDescription>{text}</AlertDescription>
    </Alert>
  );
};

export default BasicAlert;
